import { Link } from "@tanstack/react-router";
import { useEffect } from "react";

const HELPFUL_LINKS: Array<{ to: string; label: string }> = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/our-program", label: "Our Program" },
  { to: "/team", label: "Our Team" },
  { to: "/results", label: "Before & After" },
  { to: "/resources", label: "Resources" },
  { to: "/contact", label: "Contact" },
];

export function NotFound() {
  // Signal noindex to crawlers when they hit an unknown URL.
  useEffect(() => {
    if (typeof document === "undefined") return;
    const existing = document.querySelector<HTMLMetaElement>('meta[name="robots"][data-notfound]');
    if (existing) return;
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, follow";
    meta.setAttribute("data-notfound", "true");
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  return (
    <section aria-labelledby="notfound-heading" className="mx-auto max-w-3xl px-6 py-20 text-center">
      <p className="text-sm font-semibold uppercase tracking-widest text-brand-mid">404 error</p>
      <h1 id="notfound-heading" className="mt-3 text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
        We couldn&rsquo;t find that page
      </h1>
      <p className="mt-4 text-base text-muted-foreground">
        The page you&rsquo;re looking for may have moved or no longer exists. Try one of the links
        below, or head back to the homepage.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Go to homepage
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center rounded-md border border-input bg-background px-5 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-accent"
        >
          Contact us
        </Link>
      </div>

      <nav aria-label="Helpful links" className="mt-12">
        <h2 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground">
          Popular pages
        </h2>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          {HELPFUL_LINKS.map((link) => (
            <li key={link.to}>
              <Link to={link.to} className="text-brand-mid underline-offset-4 hover:underline">
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  );
}
